import { StateUtils } from '@spartacus/core';
import { RR_REC } from '../reference-state';

export const LOAD_RR_RECOMENDATION_LIST = '[Reference[RetailRocket]] RR Recomends load';
export const LOAD_RR_RECOMENDATION_LIST_SUCCESS = '[Reference[RetailRocket]] RR Recomends load success';
export const LOAD_RR_RECOMENDATION_LIST_FAIL = '[Reference[RetailRocket]] RR Recomends  load fail';
export const RESET_RR_RECOMENDATION_LIST = '[Reference[RetailRocket]] Reset RR Recomends';
export const RESET_RR_RECOMENDATION_ALL_LIST = '[Reference[RetailRocket]] Reset RR Recomends All';

export class LoadRetailRocketRecomendationList extends StateUtils.EntityLoadAction {
  readonly type = LOAD_RR_RECOMENDATION_LIST;

  constructor(
    public id: string,
    public productCodes: string[],
    public algoritmType: string,
  ) {
    super(RR_REC, id);
  }
}

export class LoadRetailRocketRecomendationListFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_RR_RECOMENDATION_LIST_FAIL;

  constructor(
    public id: string,
    payload: any,
  ) {
    super(RR_REC, id, payload);
  }
}

export class LoadRetailRocketRecomendationListSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_RR_RECOMENDATION_LIST_SUCCESS;

  constructor(
    public id: string,
    public payload: string[],
  ) {
    super(RR_REC, id, payload);
  }
}

export class ResetRetailRocketRecomendationList extends StateUtils.EntityRemoveAction {
  readonly type = RESET_RR_RECOMENDATION_LIST;

  constructor(public id: string) {
    super(RR_REC, id);
  }
}

export class ResetRetailRocketRecomendationAllList extends StateUtils.EntityRemoveAllAction {
  readonly type = RESET_RR_RECOMENDATION_ALL_LIST;

  constructor() {
    super(RR_REC);
  }
}

export type RetailRocketRecomendationListAction =
  | LoadRetailRocketRecomendationList
  | LoadRetailRocketRecomendationListFail
  | LoadRetailRocketRecomendationListSuccess
  | ResetRetailRocketRecomendationList;
